// Integração com o Asaas (cobrança) — Administração > Conta & Integrações
// (2026-08-28: migrado da antiga tela solta "Integrações" no menu lateral,
// ver admin.integrations.tsx). Backend próprio (2026-08-27),
// administrador-only (ver requireAdmin em guards/permission.guard.ts no
// backend). Mesmo padrão de gpsdrive-client-profile.service.ts.
import { gpsDriveGet, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface AsaasIntegrationStatus {
  enabled: boolean;
  // Nunca a chave em si — o backend nunca devolve a chave de API, só se
  // ela está configurada (pra UI decidir entre campo vazio e placeholder
  // "chave configurada").
  hasApiKey: boolean;
  // Dias até o vencimento de uma cobrança nova (sugestão de padrão).
  dueDays: number;
  // Dias de atraso até suspender a conta do cliente automaticamente —
  // null = suspensão automática desligada. Só a configuração é salva aqui;
  // a rotina que efetivamente suspende ainda não existe no backend.
  suspensionDays: number | null;
}

export interface UpdateAsaasIntegrationInput {
  // Omitido reaproveita a chave já salva no backend (só troca enabled) —
  // usado quando o admin só liga/desliga sem digitar uma chave nova.
  apiKey?: string;
  enabled: boolean;
  dueDays?: number;
  // null explícito desliga a suspensão automática; omitido mantém o valor
  // já salvo.
  suspensionDays?: number | null;
}

export const gpsDriveAsaasIntegrationService = {
  get: () => gpsDriveGet<AsaasIntegrationStatus>("/api/v1/integrations/asaas"),
  update: (input: UpdateAsaasIntegrationInput) =>
    gpsDrivePut<AsaasIntegrationStatus>("/api/v1/integrations/asaas", input),
};
